import type { AppLocale } from "./locales";

export type MessageCatalog = Record<string, string>;

export type LocaleCatalogs = Record<AppLocale, MessageCatalog>;

export function interpolate(template: string, values?: Record<string, string | number>): string {
  if (!values) return template;
  return template.replace(/\{(\w+)\}/g, (_, key: string) =>
    values[key] === undefined ? `{${key}}` : String(values[key]),
  );
}

function usableCatalogMessage(value: string | undefined): string | undefined {
  if (value == null || value.trim() === "") return undefined;
  return value;
}

/**
 * Choose the locale string, then English, then the key itself. Blank catalog
 * values (unfinished gettext msgstr) are skipped the same way missing keys are.
 */
export function resolvedCatalogTemplate(
  localeCatalog: Record<string, string>,
  englishCatalog: Record<string, string>,
  key: string,
): string {
  return (
    usableCatalogMessage(localeCatalog[key]) ??
    usableCatalogMessage(englishCatalog[key]) ??
    key
  );
}

export function translateFromCatalogs(
  catalogs: Record<AppLocale, MessageCatalog>,
  locale: AppLocale,
  key: string,
  values?: Record<string, string | number>,
): string {
  return interpolate(resolvedCatalogTemplate(catalogs[locale], catalogs.en, key), values);
}
